import { render, staticRenderFns } from "./mainSideBar.vue.html?vue&type=template&id=6382c1f0&"
import script from "./mainSideBar.ts?vue&type=script&lang=ts&"
export * from "./mainSideBar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports